module.exports = __webpack_public_path__ + "static/0-f1b8aa5323e152872be92c3f5c2b0995.png";